/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type portfolio_PortfolioFullRecordRequestResponse = {
    child_id?: string;
    fulfilled_at?: string;
    id?: string;
    note?: string;
    requested_at?: string;
    requested_by_contact_id?: string;
    /**
     * RequestedByUserID is the calling user's own id when they filed the request, else empty.
     */
    requested_by_user_id?: string;
    status?: portfolio_PortfolioFullRecordRequestResponse.status;
};
export namespace portfolio_PortfolioFullRecordRequestResponse {
    export enum status {
        OPEN = 'open',
        FULFILLED = 'fulfilled',
        REJECTED = 'rejected',
    }
}

